import React from 'react';
import BaseChart from '../BaseChart/BaseChart';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as ChartBarStyle from './ChartBarStyle';
import { ChartBarProps } from 'types/Chart'
import { useAppSelector } from '../../../redux/hooks';
import useMediaQuery from 'hooks/useMediaQuery';
import { MediaQuery } from 'enums/enums';

const ChartBar: React.FC<ChartBarProps> = ({ details, chartBarYAxisHeader, chartBarXAxisHeader, componentClick, formmater,
    ariaLabel, onDetailClick, isHaveDetail, displayLabels = true }) => {
    const { barLabelData, datasets } = details;
    const {isContrast} = useAppSelector(state => state.general);
    const isMobile = useMediaQuery(MediaQuery.Mobile)

    const lineHeight = isMobile ? '1' : '1.8';
    const maxCharsPerLine = isMobile ? 10 : 15;

    const plugins = {
        ...(details.plugins ?? {}),
        legend: {
          ...details.plugins?.legend,
          labels: {
            ...details.plugins?.legend?.labels,
            font: {
              size: isMobile ? 10 : 14
            }
          }
        }
    };

    const data = {
        labels: barLabelData,
        datasets: datasets.map(el => ({ ...el, maxBarThickness: 40 }))
    };

    const options = {
        ...ChartBarStyle.chartOptions(plugins, formmater, isContrast, chartBarYAxisHeader.split('\n'), maxCharsPerLine, lineHeight, chartBarXAxisHeader, displayLabels)
    };
    return (
        <div className='barChart'>
            <BaseChart
                onDetailClick={onDetailClick}
                isHaveDetail={isHaveDetail}
                chartType="bar"
                data={data}
                options={options}
                plugins={[ChartDataLabels]}
                componentClick={componentClick}
                ariaLabel={ariaLabel}
            />
        </div>
    );
};

export default ChartBar;
